import React, { useContext, useState } from "react";
import TakTwitte from "./TakTwitte";
import comment from "../../../assets/images/Icon awesome-comment.png";

import more from "../../../assets/images/Icon material-more-vert.png";
import twitteContext from "context/twitteContext";
import { twitteTime } from "./twitteTime";
import Swal from "sweetalert2";
import axios from "axios";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";

const Comments = ({ Comment, index, setComments }) => {
  const auth = useContext(AuthenticationContext);
  const { updater, setUpdater, twitte } = useContext(twitteContext);
  function text(textTwitte) {
    let reg = /#[A-Za-z\u0600-\u06FF_]+/g;
    let text = textTwitte;
    let y = text.match(reg);
    let result = text;
    if (y != null)
      y.forEach((value) => {
        result = result.replace(value, `<a style="color:red">${value} </a>`);
      });
    return <div dangerouslySetInnerHTML={{ __html: result }}></div>;
  }
  async function Alert() {
    const result = await Swal.fire({
      title: "از حذف این کامنت مطمئنید؟",
      text: "قابلیت بازگردانی آن وجود ندارد.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "حذف",
      cancelButtonText: "لغو",
    });
    if (result.isConfirmed) {
      DeleteHandler();
    }
  }
  async function DeleteHandler() {
    let fd = new FormData();
    fd.append("comment_id", Comment.comment[0].id);
    await axios
      .post("http://cryptozoom.tatdemo.ir/api2/delete_comment", fd)
      .then((res) =>
        res.data.status == 1
          ? (Swal.fire({
              title: "حذف",
              text: "کامنت شما با موفقیت حذف شد",
              confirmButtonText: "باشه",
              icon: "success",
            }),
            setUpdater(!updater))
          : Swal.fire({
              title: "خطا",
              text: "مشکلی در حذف کامنت به وجود آمده است",
              confirmButtonText: "باشه",
              icon: "error",
            })
      );
  }
  return (
    <div key={index}>
      <div className="comment twitte col-12" key={index}>
        <div style={{ textAlign: "left" }}>
          {auth.userInfo.id == twitte.maker_twit_info[0].user[0].id ? (
            <div class="btn-group dropend">
              <button
                type="button"
                class="btn dropdown-toggle the-btn"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src={more} alt="more" />
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" onClick={Alert}>
                    حذف
                  </a>
                </li>
              </ul>
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="row" style={{ alignItems: "center" }}>
          <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
            <div
              className="radius image"
              data-bs-toggle="modal"
              data-bs-target="#TwitteModal"
            >
              <img src={Comment.user_comment.profile_pic[0]} className="icon" />
            </div>
          </div>
          <div
            className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2"
            data-bs-toggle="modal"
            data-bs-target="#TwitteModal"
          >
            {Comment.user_comment.user[0].fullname}
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
            {Comment.user_comment.user[0].username}@
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
            {twitteTime(Comment.comment[0].mtm)}
          </div>
        </div>
        <div className="col-12">
          <br />
        </div>
        <div className="row">
          <div className="col-12 col-sm-10 col-md-9 col-lg-10">
            {text(Comment.comment[0].text)}
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-12 col-lg-6">
            <div className="row">
              <div className="col-6 col-sm-4 col-lg-4 col-xl-3 iconF">
                <img src={comment} alt="comment" />
                {`(${
                  Comment.reply_comment ? Comment.reply_comment.length : 0
                })`}
              </div>
            </div>
          </div>
        </div>
        {/* {Comment.reply_comment ? (
          Comment.reply_comment.length == 0 ? (
            ""
          ) : (
            <hr />
          )
        ) : (
          ""
        )} */}
        {/* {Comment.reply_comment
          ? Comment.reply_comment.map((value, ind) => {
              return (
                <Comments
                  Comment={value}
                  index={ind}
                  setComments={setComments}
                />
              );
            })
          : ""} */}
        {/* {comments.map((value, ind) => {
          return (
            <Comments Comment={value} index={ind} setComments={setComments} />
          );
        })} */}
      </div>
    </div>
  );
};

export default Comments;
